export default __webpack_public_path__ + "static/media/Quotations.68d9d5c9.svg";